export const businessInfo = {
  name: "Revive Solutions",
  tagline: "Authorised Elica Service Provider",
  location: "Wanowrie, Pune",
  phone: "7744975797",
  phoneDisplay: "+91 77449 75797",
  email: "revivesolutions123@gmail.com",
  whatsapp: "https://wa.me/917744975797",
  address: "Office No 703, One Place, Oxford Village, Salunkhe Vihar Society, Wanowrie, Pune, Maharashtra 411040",
  hours: "Mon – Sun: 9:00 AM – 8:00 PM",
  mapEmbed: "https://www.google.com/maps?q=Oxford+Village+Salunkhe+Vihar+Wanowrie+Pune&output=embed",
};

export const applianceMeta = {
  chimney: {
    slug: "chimney",
    title: "Chimney",
    label: "Elica Chimney",
    route: "/chimney-service",
    tagline: "Cleaning, deep-cleaning, motor & filter service, installation",
    image: "https://images.unsplash.com/photo-1682662044733-9120471befc7?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Elica Chimney Service & Repair in Pune | Revive Solutions",
    seoDesc: "Authorised Elica chimney service in Pune – cleaning, deep cleaning, motor repair, filter replacement and installation. Genuine parts, trained technicians.",
  },
  hob: {
    slug: "hob",
    title: "Hob",
    label: "Elica Hob",
    route: "/hob-service",
    tagline: "Burner, ignition, auto-ignition & installation service",
    image: "https://images.unsplash.com/photo-1645500178054-65acb8dfae42?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero: "https://images.unsplash.com/photo-1629234356883-c37e616a2d43?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Elica Hob Service & Repair in Pune | Revive Solutions",
    seoDesc: "Authorised Elica hob repair in Pune – burner, ignition, auto-ignition, glass and gas issue service. Doorstep visit with genuine parts.",
  },
  cooktop: {
    slug: "cooktop",
    title: "Cooktop",
    label: "Elica Cooktop",
    route: "/cooktop-service",
    tagline: "Ignition, burner and general cooktop service",
    image: "https://images.unsplash.com/photo-1629234356883-c37e616a2d43?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero: "https://images.unsplash.com/photo-1645500178054-65acb8dfae42?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Elica Cooktop Service & Repair in Pune | Revive Solutions",
    seoDesc: "Authorised Elica cooktop repair in Pune. Ignition, burner and installation service by trained technicians at your doorstep.",
  },
  oven: {
    slug: "oven",
    title: "Built-in Oven",
    label: "Elica Built-in Oven",
    route: "/oven-service",
    tagline: "Heating, temperature, control & panel issues",
    image: "https://images.pexels.com/photos/7515855/pexels-photo-7515855.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    hero: "https://images.unsplash.com/photo-1622372738946-62e02505feb3?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Elica Built-in Oven Service & Repair in Pune | Revive Solutions",
    seoDesc: "Authorised Elica built-in oven service in Pune. Heating, temperature, electrical & control panel repair by certified technicians.",
  },
  microwave: {
    slug: "microwave",
    title: "Microwave Oven",
    label: "Elica Microwave Oven",
    route: "/microwave-oven-service",
    tagline: "Not heating, electrical, door & panel repair",
    image: "https://images.unsplash.com/photo-1535230387253-9cd5be991a86?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero: "https://images.pexels.com/photos/7148841/pexels-photo-7148841.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    seoTitle: "Elica Microwave Oven Service & Repair in Pune | Revive Solutions",
    seoDesc: "Authorised Elica microwave oven service in Pune – not heating, electrical, door and control panel repair with genuine parts.",
  },
  dishwasher: {
    slug: "dishwasher",
    title: "Dishwasher",
    label: "Elica Dishwasher",
    route: "/dishwasher-service",
    tagline: "Not starting, drainage, leakage & wash-quality issues",
    image: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&q=85",
    hero: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&q=85",
    seoTitle: "Elica Dishwasher Service & Repair in Pune | Revive Solutions",
    seoDesc: "Authorised Elica dishwasher service in Pune – not starting, not draining, water leakage, wash-quality and error code repair.",
  },
};

export const trustBadges = [
  "Trained Technicians",
  "Genuine Spare Parts",
  "Transparent Pricing",
  "Doorstep Service",
];

export const whyChoose = [
  { title: "Trained Technicians", desc: "Our technicians are trained on Elica products and use factory-recommended procedures for every service." },
  { title: "Genuine Spare Parts", desc: "We only fit genuine Elica spare parts backed by manufacturer warranty. No compromises on quality." },
  { title: "Transparent Pricing", desc: "Clear starting prices for every service. Spare part cost is shared and approved before any repair begins." },
  { title: "Doorstep Service", desc: "All services – diagnostic, repair, cleaning, installation – are done at your home, at your convenience." },
  { title: "Easy Booking", desc: "Book in under a minute on the website, over WhatsApp, or by a single phone call." },
  { title: "Dedicated Kitchen Appliance Service", desc: "We are focused exclusively on Elica kitchen appliances. No AC, no fridge, no washing machines – just kitchen expertise." },
];

export const howItWorks = [
  { step: 1, title: "Choose Your Appliance", desc: "Pick from chimney, hob, cooktop, oven, microwave or dishwasher." },
  { step: 2, title: "Select Your Problem", desc: "Tell us what needs attention – or pick a service like cleaning or installation." },
  { step: 3, title: "Enter Your PIN Code", desc: "Instantly check if we serve your area in Pune." },
  { step: 4, title: "Choose Appointment", desc: "Pick a date and a time-slot that works for you." },
  { step: 5, title: "Confirm Booking", desc: "Get a booking confirmation with a job number. Pay after service." },
];

export const timeSlots = [
  "9:00 AM – 11:00 AM",
  "11:00 AM – 1:00 PM",
  "1:00 PM – 3:00 PM",
  "3:00 PM – 5:00 PM",
  "5:00 PM – 7:00 PM",
];

export const jobStatuses = [
  "New Lead",
  "Confirmed",
  "Assigned",
  "Technician On The Way",
  "Inspection",
  "Estimate Sent",
  "Customer Approval Pending",
  "Repair In Progress",
  "Completed",
  "Payment Pending",
  "Paid",
  "Closed",
  "Cancelled",
];
